/**
 * ComparisonSection Component
 * Product comparison table
 */
export function ComparisonSection() {
  const logo = `${window.template_root}/src/public/img/logo-green.svg`;
  const checkIcon = `${window.template_root}/src/public/img/check-circle.svg`;
  const crossIcon = `${window.template_root}/src/public/img/x-circle.svg`;

  const comparisonData = [
    {
      feature: "No fasting or food restriction required",
      us: true,
      others: false,
    },
    {
      feature: "Supports metabolism without stimulants",
      us: true,
      others: false,
    },
    {
      feature: "Reduces bloating without laxatives",
      us: true,
      others: false,
    },
    { feature: "Promotes clearer skin from within", us: true, others: false },
    { feature: "Sustainable long-term results", us: true, others: false },
  ];

  return (
    <section className="py-16 px-8 pb-[6.5rem] text-center max-md:py-8 max-md:px-4 max-md:pb-10">
      {/* Header */}
      <h2 className="font-family-title text-[2.5rem] font-normal mb-2 max-md:text-[1.8rem] max-md:leading-[1.25] max-md:mb-2">
        Why Naori Detox and Not Another Harsh Cleanse
      </h2>
      <p className="text-[1.1rem] text-gray max-w-[500px] mx-auto leading-relaxed max-md:text-[0.95rem]">
        Extreme detox programs punish your body. Naori works with it.
      </p>

      {/* Comparison Table */}
      <div
        className="relative max-w-[980px] mx-auto mt-16 rounded-[1.5rem] bg-white
                      max-md:mt-6 max-md:rounded-[1.2rem] max-md:overflow-hidden"
      >
        {/* Highlight Column (Desktop only) */}
        <div className="absolute inset-0 left-1/2 w-1/4 comparison-highlight pointer-events-none rounded-[16px] -my-5 max-md:hidden" />
        {/* Table Header */}
        <div
          className="relative z-[1] grid grid-cols-[2fr_1fr_1fr] items-center
                        p-0 font-semibold bg-transparent
                        max-md:grid-cols-[1.75fr_1fr_1fr] max-md:bg-white"
        >
          <div className="text-left max-md:text-[0.85rem] max-md:leading-[1.35] max-md:pl-4 md:pl-6 ">
            Benefits
          </div>
          <div className="text-center bg-transparent max-md:py-[30px] max-md:comparison-highlight">
            <img
              src={logo}
              alt="Naori"
              className="w-[82px] h-auto mx-auto max-md:w-[34px]"
            />
          </div>
          <div className="text-center p-6 bg-transparent max-md:p-0 max-md:py-4 max-md:text-[0.85rem] max-md:leading-[1.35]">
            Other Detox Programs
          </div>
        </div>

        {/* Table Rows */}
        {comparisonData.map((row, index) => (
          <div
            key={index}
            className={`relative z-10 grid grid-cols-[2fr_1fr_1fr] items-center border-t border-[rgba(46,71,27,0.05)] bg-transparent max-md:grid-cols-[1.75fr_1fr_1fr] max-md:bg-white max-md:p-0`}
          >
            <div className="p-6 text-left bg-transparent max-md:px-4 max-md:py-0 max-md:text-[0.85rem] max-md:leading-[1.35] max-md:flex max-md:items-center">
              {row.feature}
            </div>
            <div className="p-6 text-center bg-transparent max-md:p-0 max-md:py-4 max-md:justify-center max-md:comparison-highlight max-md:flex max-md:items-center">
              {row.us ? (
                <img
                  src={checkIcon}
                  alt="Yes"
                  className="w-9 h-9 mx-auto max-md:w-[26px] max-md:h-[26px]"
                />
              ) : (
                <img
                  src={crossIcon}
                  alt="No"
                  className="w-8 h-8 mx-auto max-md:w-[26px] max-md:h-[26px]"
                />
              )}
            </div>
            <div className="p-6 text-center bg-transparent max-md:p-0 max-md:py-4 max-md:justify-center max-md:flex max-md:items-center">
              {row.others ? (
                <img
                  src={checkIcon}
                  alt="Yes"
                  className="w-9 h-9 mx-auto max-md:w-[26px] max-md:h-[26px]"
                />
              ) : (
                <img
                  src={crossIcon}
                  alt="No"
                  className="w-8 h-8 mx-auto max-md:w-[26px] max-md:h-[26px]"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ComparisonSection;
